import { dispatchCustomEvent } from "./dispatchCustomEvent";
export const REMOVE_NOTIFICATION_CUSTOM_EVENT_NAME = "REMOVE_NOTIFICATION_CUSTOM_EVENT_NAME";
export const removeNotification = (notificationId) => {
    dispatchCustomEvent(REMOVE_NOTIFICATION_CUSTOM_EVENT_NAME, {
        canBeCancelled: false,
        bubble: false,
        detail: {
            id: notificationId,
        },
    });
};
//# sourceMappingURL=removeNotification.js.map